// extracted by mini-css-extract-plugin
export default {"qty-value":"kiy5LesjJEgrZxoy5KHK"};